import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBTextField, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestGazeStabilization extends React.Component {
    
    render() {      
        return (
            <div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZESMOOTHPURSUIT} flagText='Gaze Stabilization - Smooth Pursuit'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Smooth Pursuit</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZESMOOTHPURSUIT'
                        className={styles.out_measure_other}
                        />
                </div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZESACHORZ} flagText='Gaze Stabilization - Saccades Horizontal'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Saccades Horizontal  </label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZESACHORZ'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZESACVERT} flagText='Gaze Stabilization - Saccades – Vertical'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Saccades – Vertical</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZESACVERT'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZEVORHEADTHRUST} flagText='Gaze Stabilization - VOR Head Thrust'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>VOR Head Thrust (Horizontal)</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZEVORHEADTHRUST'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZEVORCANCEL} flagText='Gaze Stabilization - VOR Cancellation'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>VOR Cancellation</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZEVORCANCEL'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZESPONTANEOUS} flagText='Gaze Stabilization - Spontaneous'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Spontaneous</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZESPONTANEOUS'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZEEVOKED} flagText='Gaze Stabilization - Gazed-evoked'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Gazed-evoked</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZEEVOKED'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZEHEAVE} flagText='Gaze Stabilization - Heave Testing'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Heave Testing (Utricular)</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZEHEAVE'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZECONVERGE} flagText='Gaze Stabilization - Convergence'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Convergence</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZECONVERGE'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZEHEADSHAKE} flagText='Gaze Stabilization - Head Shake'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Head Shake</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZEHEADSHAKE'
                        className={styles.out_measure_other}
                        />
                </div>   
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flaggedTSGAZEHTEST} flagText='Gaze Stabilization - H Test'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>H Test</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSGAZEHTEST'
                        className={styles.out_measure_other}
                        />
                </div>      
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

            let flaggedTSGAZESMOOTHPURSUIT = false
            let flaggedTSGAZESACHORZ = false
            let flaggedTSGAZESACVERT = false
            let flaggedTSGAZEVORHEADTHRUST = false
            let flaggedTSGAZEVORCANCEL = false
            let flaggedTSGAZESPONTANEOUS = false
            let flaggedTSGAZEEVOKED = false
            let flaggedTSGAZEHEAVE = false
            let flaggedTSGAZECONVERGE = false
            let flaggedTSGAZEHEADSHAKE = false
            let flaggedTSGAZEHTEST = false
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZESMOOTHPURSUIT) {
                flaggedTSGAZESMOOTHPURSUIT = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZESACHORZ) {
                flaggedTSGAZESACHORZ = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZESACVERT) {
                flaggedTSGAZESACVERT = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZEVORHEADTHRUST) {
                flaggedTSGAZEVORHEADTHRUST = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZEVORCANCEL) {
                flaggedTSGAZEVORCANCEL = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZESPONTANEOUS) {
                flaggedTSGAZESPONTANEOUS = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZEEVOKED) {
                flaggedTSGAZEEVOKED = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZEHEAVE) {
                flaggedTSGAZEHEAVE = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZECONVERGE) {
                flaggedTSGAZECONVERGE = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZEHEADSHAKE) {
                flaggedTSGAZEHEADSHAKE = true;
            }
            if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSGAZEHTEST) {
                flaggedTSGAZEHTEST = true;
            }

    return {
        noteId: noteId,
        tsno: tsno,
        flaggedTSGAZESMOOTHPURSUIT :flaggedTSGAZESMOOTHPURSUIT,
        flaggedTSGAZESACHORZ : flaggedTSGAZESACHORZ,
        flaggedTSGAZESACVERT : flaggedTSGAZESACVERT,
        flaggedTSGAZEVORHEADTHRUST : flaggedTSGAZEVORHEADTHRUST,
        flaggedTSGAZEVORCANCEL : flaggedTSGAZEVORCANCEL,
        flaggedTSGAZESPONTANEOUS :flaggedTSGAZESPONTANEOUS,
        flaggedTSGAZEEVOKED : flaggedTSGAZEEVOKED,
        flaggedTSGAZEHEAVE : flaggedTSGAZEHEAVE,
        flaggedTSGAZECONVERGE : flaggedTSGAZECONVERGE,
        flaggedTSGAZEHEADSHAKE : flaggedTSGAZEHEADSHAKE,
        flaggedTSGAZEHTEST : flaggedTSGAZEHTEST
    };
}

const connectedSpecialTestGazeStabilization = connect(mapStateToProps, mapDispatchToProps)(SpecialTestGazeStabilization);
export {connectedSpecialTestGazeStabilization as SpecialTestGazeStabilization };